var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);} /* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Translate } from "../../../../I18N";
import { Tooltip } from 'flowbite-react';
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';
import { EnableButtonCheckbox } from "../../../Components/Forms";











const CollectionOptionToggle = ({
  register,
  valueKey,
  label,
  tip,
  defaultChecked
}) => /*#__PURE__*/
_jsx("div", { className: "flex col-span-2 gap-4 items-center" }, void 0, /*#__PURE__*/
React.createElement(EnableButtonCheckbox, _extends({}, register(valueKey), { defaultChecked: defaultChecked })), /*#__PURE__*/
_jsx(Translate, { className: "text-sm font-medium text-gray-900" }, void 0, label), /*#__PURE__*/
_jsx(Tooltip
// eslint-disable-next-line react/style-prop-object
, { style: "light",
  content: tip,
  placement: "right" }, void 0, /*#__PURE__*/

_jsx(QuestionMarkCircleIcon, { className: "w-5 h-5 text-gray-500" })
)
);


export { CollectionOptionToggle };